'use client';

import { useContext } from 'react';
import { ConfigContextType } from '..';
import { ConfigContext } from './ConfigProvider';

export const useConfig = (): ConfigContextType => {
  const context = useContext(ConfigContext);

  if (context == null) {
    throw new Error('useConfig hook was used without ConfigProvider.');
  }

  return context;
};

export { ConfigProvider } from './ConfigProvider';
